(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::error
 (fn [db [_ error-path]]
   (get-in db error-path)))

(rf/reg-sub
 ::show?
 (fn [db [_ error-path]]
   (get-in db error-path)))

(rf/reg-sub
 ::upload-status
 (fn [db [_ status-path]]
   (get-in db status-path)))
